
<template>
  <div id="app">
    <div class="header">
      <!-- BEM 命名法，css常用写法  -->

      <div
        class="headerSearch"
        @mouseover="showSearch = true"
        @mouseleave="showSearch = false"
      >
        <input type="text" class="trigger-input" placeholder="常用功能" />
        <search-input class="custom-search-input" v-if="showSearch" />
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from "./components/SearchInput.vue";

export default {
  name: "App",
  components: {
    SearchInput,
  },
  data() {
    return {
      showSearch: false,
    };
  },
  methods: {
    handleBlur() {
      // 使用 setTimeout 是为了确保在 mouseover 事件触发之前不会立即隐藏 search-input
      setTimeout(() => {
        if (!this.isMouseOverSearchInput) {
          this.showSearch = false;
        }
      }, 1000);
    },
  },
};
</script>

